module.exports = __webpack_public_path__ + "img/岗位统计.7c43520f.svg";